module.exports = __webpack_public_path__ + "./img/iso-darsur.a3cf8c4f5ffd3d53ba2406fb0c9db1ba.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/iso-darsur.jpg
// module id = ./src/assets/img/brand/iso-darsur.jpg
// module chunks = 14